import * as React from "react";
import { SubmitButtonProps } from "./typings";
import { UitkPrimaryButton, UitkButtonSize } from "uitk-react-button";
import { formatText } from "bernie-l10n";

export const SubmitButton: React.FunctionComponent<SubmitButtonProps> = ({ classes, lobState }) => (
  <div className={classes}>
    <UitkPrimaryButton
      tag="button"
      type="submit"
      text={formatText(lobState.config.form.submitButton.locToken)}
      size={UitkButtonSize.LARGE}
      isFullWidth={true}
    />
  </div>
);
